import { contextKeys, initDataType } from '../types/initDataTypes.ts'

interface Appendable {
  append: (name: string, value: string) => void
}

function composeParameter(
  parameterStore: Appendable,
  initData: initDataType,
  keyWrapper: (key: string) => string = (key) => key
) {
  contextKeys.forEach((key) => {
    if (initData[key]) {
      parameterStore.append(keyWrapper(key), initData[key])
    }
  })
}

export function composeHeaderParameter(initData: initDataType) {
  const headerStore = new Headers()
  initData.gandalfToken &&
    headerStore.append('Authorization', `Bearer ${initData.gandalfToken}`)
  composeParameter(headerStore, initData, (rawHeader) => `x-${rawHeader}`)
  return headerStore
}

export function composeQueryParameter(initData: initDataType) {
  const searchParameter = new URLSearchParams()
  composeParameter(searchParameter, initData)
  return searchParameter.toString()
}
